export async function revalidateListOnDetailExit({
  currentId,
  previousId,
  revalidate
}) {
  if (!previousId || currentId) {
    return false;
  }

  await revalidate();
  return true;
}
